module.exports = __webpack_public_path__ + "img/logo-small.829ff840.png";